import { useCallback, useEffect, useRef, useState } from "react";

export const useDebouncedKeywordState = (debounceMs: number = 500) => {
  const [keyword, setKeyword] = useState("");
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const schedule = useCallback(
    (raw: string) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setKeyword(raw.trim()), debounceMs);
    },
    [debounceMs],
  );

  /**
   * 待たずに今の値を確定する。入力欄から離れたとき（blur）や Enter のように、
   * 「打ち終わった」と分かる合図があるときに使う。
   */
  const flush = useCallback((raw: string) => {
    clearTimeout(timeoutRef.current);
    setKeyword(raw.trim());
  }, []);

  const reset = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setKeyword("");
  }, []);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return { keyword, schedule, flush, reset };
};
